
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clock",
      function () {
        return require("private-next-pages/clock.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clock"])
      });
    }
  